import React, { act, useEffect } from "react"
import MetaTags from 'react-meta-tags';
import Select from 'react-select'

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Form,
} from "reactstrap"

//Import Breadcrumb
import { Link } from 'react-router-dom';
import { useState } from "react";
import { useRef } from "react";
import { PropTypes } from 'prop-types';
import { Alert } from "reactstrap";
import { getClientDetail, getProducts, getRegimenesFiscales, getSatUseCfdi, postClient, putClient, validateZipCode } from "helpers/backend_helper";
import BreadcrumbNav from "components/Common/BreadcrumbNav";

import toastr from "toastr"
import { useNibbleForm } from "components/Nibble/Hooks/UseNibbleForm";
import * as Yup from 'yup';
import { MEXICO_STATES } from "helpers/states";
import Tabs, { tabsClients } from "./components/Tabs";
import DeliveryAddress from "./components/DeliveryAddress";
import ProductsAssigned from "./components/ProductsAssigned";

const cpRegExp = /^[0-9]{5}/;

const CatalogClientForm = (props) => {
  const isEdit = props?.location?.state?.id ? true : false;
  const breadcrumbItems = [
    { id: '1', title: 'Catálogos', link: '', active: false },
    { id: '2', title: 'Clientes', link: '/catalogs/clients', active: false },
    { id: '3', title: isEdit ? 'Editar' : 'Crear', link: '', active: true }
  ];

  // Catalogs
  const [satUseCfdi, setSatUseCfdi] = useState([])
  const [satRegimenFiscal, setSatRegimenFiscal] = useState([])
  const [productos, setProductos] = useState([])

  // States
  const [model, setModel] = useState({ ...props.location.state })
  const [error, setError] = useState(null)
  const [completed, setCompleted] = useState(null)
  const [btnSaveLoad, setBtnSaveLoad] = useState(false)
  const [activeTab, setActiveTab] = useState('generales');

  async function getDataModel() {
    const response2 = await getClientDetail(model.id)
    console.log('response2', response2)
    setModel({ ...model.invoice_address, ...model, ...response2, deliveries_address: response2.deliveries_address, distribuitors: response2.distribuitors })
  }

  useEffect(() => {
    getSatUseCfdi().then(setSatUseCfdi)
    getRegimenesFiscales().then(setSatRegimenFiscal)
    getProducts().then(setProductos)
    getDataModel();
  }, [])

  const { validation, render } = useNibbleForm({
    formScheme: [
      {
        md: 8,
        name: 'company_name',
        label: 'Nombre Comercial o Razón Social',
        type: 'text',
      },
      {
        md: 4,
        name: 'skey',
        label: 'Clave Interna',
        type: 'text',
      },
      {
        md: 8,
        name: 'contact_name',
        label: 'Nombre Completo Persona Contacto',
        type: 'text',
      },
      {
        md: 4,
        name: "fee_per_unit",
        label: "Comisión por unidad ($)",
        type: "number",
      },
      {
        md: 4,
        name: 'rfc',
        label: 'RFC',
        type: 'text',
      },
      {
        md: 4,
        name: 'tax_regime',
        label: 'Régimen Fiscal',
        type: 'select',
        selectOptionValue: (option) => option.code,
        selectOptionLabel: (option) => `${option.code} - ${option.description}`,
        selectItems: satRegimenFiscal,
      },
      {
        md: 4,
        name: 'use_cfdi',
        label: 'Uso de CFDI',
        type: 'select',
        selectOptionValue: (option) => option.code,
        selectOptionLabel: (option) => `${option.code} - ${option.description}`,
        selectItems: satUseCfdi,
      },
      {
        md: 4,
        name: 'phone',
        label: 'Teléfono',
        type: 'text',
      },
      {
        md: 4,
        name: 'phone2',
        label: 'Teléfono 2',
        type: 'text',
      },
      {
        md: 4,
        name: 'email',
        label: 'Correo Electrónico',
        type: 'email'
      },
      {
        md: 12,
        name: 'street',
        label: 'Calle',
        type: 'text',
      },
      {
        md: 4,
        name: 'ext_num',
        label: 'Num. Ext.',
        type: 'text',
      },
      {
        md: 4,
        name: 'int_num',
        label: 'Num. Int.',
        type: 'text',
      },
      {
        md: 4,
        name: 'cp',
        label: 'C.P.',
        type: 'text',
      },
      {
        name: 'location',
        label: 'Colonia',
        type: 'text',
      },
      {
        name: 'city',
        label: 'Ciudad/Municipio',
        type: 'text',
      },
      {
        name: 'state',
        label: 'Estado',
        type: 'select',
        selectItems: MEXICO_STATES,
      },
      {
        name: 'country',
        label: 'País',
        type: 'text',
        disabled: true,
      },
      /*
      {
        md: 6,
        name: 'productos',
        label: 'Productos Asignados Para Venta',
        type: 'multi-select',
        selectOptionValue: (option) => option.id,
        selectOptionLabel: (option) => option.name,
        selectItems: productos,
        onChange: (option) => {
          setSelectedRegion(option ? option.id : null)
        }
      },
      {
        md: 6,
        name: 'product_adjust',
        label: 'Máxima cantidad de ajuste por producto',
        type: 'number',
      },
      */
      {
        md: 2,
        name: 'label',
        label: 'Horario Pedidos Cliente',
        type: 'hidden',
      },
      {
        md: 2,
        name: 'start',
        label: '',
        type: 'time',
      },
      {
        md: 2,
        name: 'end',
        label: '',
        type: 'time',
      },
    ],
    validationScheme: Yup.object().shape({
      company_name: Yup.string().required('Requerido'),
      skey: Yup.string().nullable(),
      contact_name: Yup.string().required('Requerido'),
      fee_per_unit: Yup.number().required('Requerido').min(0, 'Debe ser mayor o igual a 0'),
      rfc: Yup.string().required('Requerido'),
      tax_regime: Yup.string().required('Requerido'),
      use_cfdi: Yup.string().required('Requerido'),
      phone: Yup.string().nullable().required('Requerido'),
      phone2: Yup.string().nullable(),
      email: Yup.string().email('Correo no válido').required("Requerido"),
      street: Yup.string().required('Requerido'),
      ext_num: Yup.string().required('Requerido'),
      int_num: Yup.string().nullable(),
      cp: Yup.string().matches(cpRegExp, 'Código postal no válido').required('Requerido'),
      location: Yup.string().required('Requerido'),
      city: Yup.string().required('Requerido'),
      state: Yup.string().required('Requerido'),
      country: Yup.string().required('Requerido'),
      start: Yup.string().required('Requerido'),
      end: Yup.string().required('Requerido'),
    }),
    defaultModelValues: {
      fee_per_unit: "1.00",
      country: 'México',
      city: 'Puebla',
      start: '10:00',
      end: '11:00'
    },
    model: { ...model },
    onSubmit: async (values) => {
      console.log('values', values)
      try {
        const resp = await validateZipCode({ cp: values.cp })
        if (!resp.cp) {
          toastr.error('Código postal no válido');
          return;
        };
      } catch (error) {
        console.log('error validating zip code', error)
        toastr.error(error);
      }

      setBtnSaveLoad(true)
      try {
        setError(null)
        if (!isEdit) {
          const response = await postClient({ ...values })
        } else {
          const response = await putClient({ id: model.id, ...values })
        }
        setCompleted('Se completo la operación')
      } catch (error) {
        console.log('error', error)
        setError(error.toString())
        setCompleted(null)
      }
      setBtnSaveLoad(false)
    }
  })

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Catálogo de Clientes</title>
        </MetaTags>
        <Container fluid={true}>
          <BreadcrumbNav title="Clientes" items={breadcrumbItems} />
          <Row>
            <Col lg={12}>
              {isEdit &&
                <Tabs tabActive={activeTab} setTabActive={setActiveTab} />
              }
              {activeTab == tabsClients.generales &&
                <Card>
                  <CardBody>
                    {
                      //JSON.stringify(validation.values)
                    }
                    {
                      //JSON.stringify(validation.values)
                    }
                    <Form
                      className="form-horizontal"
                      onSubmit={(e, v) => {
                        e.preventDefault();
                        console.log('submit');
                        validation.handleSubmit()
                        return false;
                      }}
                    >
                      {error ? <Alert color="danger">{error}</Alert> : null}
                      {completed ? <Alert color="success">{completed}</Alert> : null}
                      <Row>
                        {render()}
                      </Row>
                      <div className="text-center mb-5 mt-4">
                        {(!completed || isEdit) &&
                          <button type="submit" className="btn btn-sm btn-danger w-md" disabled={btnSaveLoad}>
                            <i className="fas fa-save"></i> Guardar
                          </button>
                        }
                        <Link to="/catalogs/clients" className="btn w-md btn-sm btn-danger ms-2">
                          <i className="fas fa-reply"></i> Atrás
                        </Link>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              }
              {activeTab == tabsClients.direccionesEntrega &&
                <DeliveryAddress model={model} setModel={setModel} />
              }
              {activeTab == tabsClients.productosAsignados &&
                <ProductsAssigned model={model} setModel={setModel} />
              }
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

CatalogClientForm.propTypes = {
  provider: PropTypes.object,
  location: PropTypes.object,
};

export default CatalogClientForm
